// src/modules/app-views/goodsReceipt/components/CardHeaderGoodsReceiptOperationItems.jsx
// *******************************************************************************
// CARD HEADER COLUMN 2: Operation Nature, Item Count, Origin
// *******************************************************************************
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleColumn from 'components/SimpleComponents/SimpleColumn';
import { SwapOutlined, UnorderedListOutlined, ImportOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
export const CardHeaderGoodsReceiptOperationItems = ({
  showItem1 = true,
  showItem2 = true,
  showItem3 = true,
  forceShow = false,
  ...record
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  // Operation nature
  const operationNature = record?.operationNature || null;

  // Item count
  const itemCount = record?.items?.length || 0;

  // Origin (manual or XML import)
  const origin = record?.origin;
  const originLabel = origin ? translateX(origin) : null;

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  const items = [
    {
      key: 'operationNature',
      icon: <SwapOutlined />,
      label: operationNature || <span className="text-muted opacity-0-6">N/D</span>,
      tooltipText: translateX('operation_nature'),
      tooltipPlacement: 'right',
      onClick: null,
      hidden: !showItem1,
    },
    {
      key: 'itemCount',
      icon: <UnorderedListOutlined />,
      label: `${itemCount} ${translateX(itemCount === 1 ? 'item' : 'items')}`,
      tooltipText: translateX('items'),
      tooltipPlacement: 'right',
      onClick: null,
      hidden: !showItem2,
    },
    {
      key: 'origin',
      icon: <ImportOutlined />,
      label: originLabel || <span className="text-muted opacity-0-6">N/D</span>,
      tooltipText: translateX('origin'),
      tooltipPlacement: 'right',
      onClick: null,
      hidden: !showItem3,
    },
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return <SimpleColumn items={items?.filter(i => (i?.label || forceShow) && !i.hidden)} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CardHeaderGoodsReceiptOperationItems;
